module.exports = __webpack_public_path__ + "img/icon2.5666365b.png";